export default {
  '***': {
    '***': [
      {
        metric: 1,
        label: 'Ad Effect Score',
        inHeader: true,
        rowType: 'demphasized',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        label: 'IN-MARKET POTENTIAL',
        rowType: 'hb0'
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 2,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 3,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 4,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 5,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 6,
        label: 'Follow or otherwise interact with the brand on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 7,
        label: 'Talk about the ad to friends or family',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 8,
        label: 'Contact this brand directly (call, email, DM, etc.)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 9,
        label: 'Compare the prices/deals offered against competitors ',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 11,
        label: 'Go to a dealer to see / test drive a vehicle',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 12,
        label: 'Take advantage of an offer or promotion',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 10,
        label: 'Purchase or lease a vehicle from this company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },
      {
        metric: 13,
        label: 'Aided Brand Recognition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 14,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 15,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 17,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 18,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'h0'
      },
      {
        metric: 44,
        label: 'Category Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 45,
        label: 'Has features / tech to make my lifestyle easier',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 46,
        label: 'Focuses on safety',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 47,
        label: 'Innovative',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 48,
        label: 'Fun to drive',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 49,
        label: 'Focues on fuel efficiency',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 65,
        label: 'Focuses on performance',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      // {
      //   metric: 51,
      //   label: 'Reliable',
      //   rowType: 'd0',
      //   dataFormat: 'idx',
      //   reverseStat: false
      // },
      {
        metric: 19,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 20,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 23,
        label: 'Fulfills my needs',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 21,
        label: 'Portrays a brand I want to be associated with',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 22,
        label: 'Shows/talks about a vehicle I\'d really love to buy',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 66,
        label: 'Brand I trust',
        rowType: 'd0i',
        dataFormat: 'idx',
        reverseStat: false
      },
      // {
      //   metric: 25,
      //   label: 'Modern',
      //   rowType: 'd0i',
      //   dataFormat: '.,2',
      //   reverseStat: false
      // },
      {
        metric: 58,
        label: 'Product Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 59,
        label: 'Offers vehicles that are a good value for the money',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 60,
        label: 'Offers vehicles/features that are different from others',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 61,
        label: 'Offers high quality vehicles & services',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      // {
      //   metric: 67,
      //   label: 'Luxurious',
      //   rowType: 'd0',
      //   dataFormat: 'idx',
      //   reverseStat: false
      // },
      // {
      //   metric: 63,
      //   label: 'Luxurious',
      //   rowType: 'd0i',
      //   dataFormat: 'idx',
      //   reverseStat: false
      // },
      // {
      //   metric: 64,
      //   label: 'Technologically advanced',
      //   rowType: 'd0i',
      //   dataFormat: 'idx',
      //   reverseStat: false
      // },
      {
        metric: 33,
        label: 'Engagement',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 34,
        label: 'Worth talking about',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      // {
      //   metric: 70,
      //   label: 'Visually appealing',
      //   rowType: 'd0',
      //   dataFormat: 'idx',
      //   reverseStat: false
      // },
      {
        metric: 35,
        label: 'Memorable',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 41,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 36,
        label: 'Attention grabbing',
        rowType: 'd0i',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 37,
        label: 'Entertaining',
        rowType: 'd0i',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 38,
        label: 'Humorous',
        rowType: 'd0i',
        dataFormat: 'idx',
        reverseStat: false
      },
      // {
      //   metric: 39,
      //   label: 'Heartwarming',
      //   rowType: 'd0i',
      //   dataFormat: 'idx',
      //   reverseStat: false
      // },
      // {
      //   metric: 40,
      //   label: 'Unique',
      //   rowType: 'd0i',
      //   dataFormat: 'idx',
      //   reverseStat: false
      // },
      {
        metric: 42,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: 'idx',
        reverseStat: true
      },
      {
        metric: 68,
        label: 'Annoying',
        rowType: 'd0i',
        dataFormat: 'idx',
        reverseStat: true
      },
      {
        metric: 69,
        label: 'Inspiring',
        rowType: 'd0i',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 26,
        label: 'Cognition',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 27,
        label: 'Tells me something new',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 28,
        label: 'Credible coming from this brand',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 29,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 30,
        label: 'Good fit with brand',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 31,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 32,
        label: 'Presents info at a good pace',
        rowType: 'd0i',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 52,
        label: 'Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 54,
        label: 'Reassuring',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 53,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 55,
        label: 'Relevant to me',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 56,
        label: 'Shows people/situations I can relate to',
        rowType: 'd0',
        dataFormat: 'idx',
        reverseStat: false
      },
      // {
      //   metric: 57,
      //   label: 'Addresses an issue that\'s important to me',
      //   rowType: 'd0i',
      //   dataFormat: '.,2',
      //   reverseStat: false
      // },
      {
        label: '',
        rowType: 'eol'
      }
    ]
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/Hyundai/config/components/scorecard/MetricsLabels/metricsLabels.js